export const skills = [
  "Ruby on Rails",
  "React",
  "CSS",
  "AWS",
  "GCP",
  "Docker",
  "CI/CD",
  "GA4",
  "Data Analysis",
];
export const designation = "Full Stack Developer";
export const summary =
  "I am a Software Engineer with over 6 years of expertise in analyzing technical requirements, devising innovative designs, implementing robust code strategies and providing comprehensive support for internet scale solutions using advanced cloud technologies.";
